export default () => {
  const button = document.querySelector('.js-toggle-nav')
  const mobileNav = document.querySelector('.js-mobile-nav')
  const mobileChild = document.querySelectorAll('.js-mobile-child')
  const desc = document.querySelector(".js-toggle-desc")

  if (! button) return

  button.addEventListener('click', e => {
    document.body.classList.toggle('nav-is-active')
    document.documentElement.classList.toggle('nav-is-active') //html
    mobileNav.classList.toggle('active')

    if (document.body.classList.contains('nav-is-active')) {
      desc.innerHTML = 'sluiten'
    } else {
      desc.innerHTML = 'menu'
    }
  })

  if (mobileChild.length) {
    ;[...mobileChild].forEach(child => {

      const target = child.querySelector('.js-mobile-child-container')
      child.addEventListener('click', e => {
        target.classList.toggle('active')
        child.classList.toggle('active')
      })

    })
  }

}


// WEBPACK FOOTER //
// ./src/js/modules/MobileNav.js